import { Component, OnInit } from '@angular/core';
import { DashboardRestService } from '../dashboard-rest.service';
import { AuthenticationService } from '../../../libraries/libraries.module';
import { formatRupiah } from 'apps/admin-web/src/app/shared/utils';
import Swal from 'sweetalert2';
import { DashboardCommunicationService } from '../dashboard-communication.service';

declare var snap: any;

@Component({
  selector: 'app-top-up',
  templateUrl: 'top-up.component.html',
  styleUrls: ['./top-up.component.scss']
})
export class TopUpComponent implements OnInit {
  formatRupiah = formatRupiah;
  isProcessing: boolean = false;
  isDealership: boolean = false;
  isOpen: boolean = false;
  presetValues = [250000, 1000000, 2500000, 3000000, 5000000, 7000000];
  topUpValue: number = 100000;

  get orderData() {
    return {
      subtotal: this.topUpValue,
      fee: 0,
      total: this.topUpValue
    };
  }

  selectPreset(value: number) {
    this.topUpValue = value;
  }

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }

  constructor(
    private _DashboardRest: DashboardRestService,
    public _authentication: AuthenticationService,
    private _dashboardCommunication: DashboardCommunicationService
  ) {}

  // Open Midtrans Snap popup
  openSnap(id: string, snapToken: string) {
    snap.pay(snapToken, {
      onSuccess: (result: any) => {
        console.log('Payment success:', result);
        Swal.fire({
          icon: 'success',
          title: 'Payment Success!',
          text: 'Your top-up has been processed successfully.',
          confirmButtonText: 'OK'
        });
        this.isProcessing = false;
        this._DashboardRest.updateTransactionId(id, result.transaction_id).subscribe({
          next: () => {
            this._dashboardCommunication.triggerTransactionHistoryRefresh();
            this.closeModal();
          },
          error: (error) => {
            console.error('Error updating transaction ID:', error);
          }
        });
      },
      onPending: (result: any) => {
        console.log('Payment pending:', result);
        Swal.fire({
          icon: 'info',
          title: 'Payment Pending',
          text: 'Your payment is being processed. Please wait for confirmation.',
          confirmButtonText: 'OK'
        });
        this.isProcessing = false;
        this._DashboardRest.updateTransactionId(id, result.transaction_id).subscribe({
          next: () => {
            this._dashboardCommunication.triggerTransactionHistoryRefresh();
            this.closeModal();
          },
          error: (error) => {
            console.error('Error updating transaction ID:', error);
          }
        });
      },
      onError: (result: any) => {
        console.log('Payment error:', result);
        Swal.fire({
          icon: 'error',
          title: 'Payment Failed',
          text: 'Your payment could not be processed. Please try again.',
          confirmButtonText: 'OK'
        });
        this.isProcessing = false;
      },
      onClose: () => {
        console.log('Payment popup closed');
        this.isProcessing = false;
      }
    });
  }

  processPayment() {
    this.isProcessing = true;

    this._DashboardRest.getSnapToken(this.orderData).subscribe({
      next: (response: { transactionHistory: any, token: string, redirectUrl: string }) => {
        const id = response.transactionHistory._id;
        this.openSnap(id, response.token);
      },
      error: error => {
        console.error('Error getting snap token:', error);
        this.isProcessing = false;
        Swal.fire({
          icon: 'error',
          title: 'Payment Failed',
          text: 'Failed to initialize payment. Please try again.',
          confirmButtonText: 'OK'
        });
      }
    });
  }

  ngOnInit() {
    console.log('authentication', this._authentication.user);
  }
}
